import React from 'react';
import { Modal } from 'react-bootstrap';

import FancyButton from '../components/ui/fancyButton';
import './FormModal.css'; // Custom styling for blur effect

const FormModal = ({ show, onClose, title, children }) => {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" className="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <FancyButton variant="tertiary" onClick={onClose}>
          Close
        </FancyButton>
      </Modal.Footer>
    </Modal>
  );
};

export default FormModal;
